<template lang="pug">
	.search-autosuggest(ref="root")
		.stretched-layer(v-if="items.length", @click="reset")
		.search-autosuggest-form
			span.sr-only#search-autosuggest-usage Kezdje el beképelni a kereső mezőbe a kívánt szöveget. Majd a legördülő menüben kurzor segítségével válassza ki a kivánt elemet. Az enter billentyűvel indítja a keresést.
			label(
				:for="id", 
				:class="isVisibleLabel ? 'search-autosuggest-form__label' : 'sr-only'"
			)
				| Keresés
			.search-autosuggest-form__overflow-container
				.search-autosuggest-form__hover-container
					ul.search-autosuggest__tags(aria-label="Kiválasztott települések" v-if="tags.length", @click="focusInput")
						li.search-autosuggest__tag(v-for="(tag, index) in tags")
							span {{tag}}
							button(type="button", aria-label="Suggestion 1 eltávolítása a listából", @click.stop="removeTag(index)")
								<svg version="1.1" x="0px" y="0px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><g><path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z"></path></g></svg>
					.search-autosuggest-form__input-container
						input.search-autosuggest-form__input(
							v-if="!maxTagsReached"
							:id="id", 
							type="text", 
							ref="search-input", 
							name="searchQueryValue", 
							v-model="model.token", 
							:class="[hasResetButton ? 'search-autosuggest-form__input--left search-autosuggest-form__input--right' : 'search-autosuggest-form__input--' + buttonPosition]", 
							:placeholder="placeholder", 
							autocomplete="off", 
							role="combobox", 
							aria-haspopup="listbox", 
							aria-autocomplete="both", 
							:aria-controls="resultElementId", 
							:aria-activedescendant="activeItem != null ? resultItemElementId + activeItem : ''", 
							aria-describedby="search-autosuggest-usage", 
							@keydown.down="moveDown", 
							@keydown.up="moveUp", 
							@keypress.enter="hit", 
							@keydown.esc="reset", 
							@input="update",
							@keydown.tab="onTab",
							@focus="setFocusRing",
							@blur="onBlur"
						)
						.search-autosuggest-result(
							:id="resultElementId", 
							v-if="items.length", 
							:aria-hidden="(items.length==0) ? 'true' : 'false'"
						)
							p.sr-only(
								aria-live="polite",
								aria-atomic="true",
							)
								| találatok száma : {{ items.length }}
							ul.search-autosuggest-result__list(
								role="listbox", 
								tabindex="0", 
								ref="dropdown-menu-list"
							)
								li.search-autosuggest-result__list-item(
									v-for="(item, index) in items", 
									ref="searchItems",
									:key="index", 
									:class="{ 'search-autosuggest-result__list-item--active' : activeItem == index }", 
									:id="resultItemElementId + index", role="option", :aria-selected="(activeItem == index) ? 'true' : 'false'", 
									tabindex="-1"
								)
									a.search-autosuggest-result__link(@click.prevent.stop="selectItem(index)") {{item.value}}
</template>

<script>
import debounce from 'lodash.debounce';
const SEARCH_MIN_CHARS = 3;
const MAX_TAGS = 6;
const FOCUS_CSS_CLASS = 'search-autosuggest--has-focus';
import { M_NUMBER_REGEX } from '../../../common/js/constants/constants';
import uniq from 'ramda/src/uniq';
export default {
	name: 'SearchAutosuggest',
	data: () => ({
		items: [],
		activeItem: null,
		model: {
			token: '',
			selected: []
		},
		id: null,
		resultElementId: null,
		resultItemElementId: null
	}),
	props: {
		value: {
			required: true
		},
		suggestions: {
			required: true,
			type: Array
		},
		placeholder: {
			default: '',
			type: String
		},
		labelProp: {
			required: true,
			type: String
		},
		sendLabel: {
			type: Boolean
		},
		buttonPosition: {
			required: false,
			type: String,
			default: 'right',
			validator(value) {
				return ['left', 'right'].indexOf(value) !== -1;
			}
		},
		isVisibleLabel: {
			required: false,
			type: Boolean,
			default: false
		},
		hasResetButton: {
			required: false,
			type: Boolean,
			default: false
		}
	},
	mounted() {
		// this.id = this.$el.attributes[0].name + '-' + this._uid;
		this.resultElementId = this.id + '-result';
		this.resultItemElementId = this.id + '-item';
	},
	watch: {
		value: {
			handler(val) {
				if (val) {
					if (Array.isArray(val)) {
						this.model.selected = val;
					}
				}
			},
			immediate: true
		},
		suggestions: {
			handler(val) {
				if (val) {
					this.items = [...val];
				}
			},
			immediate: true
		}
	},
	computed: {
		tags() {
			return this.model.selected && this.model.selected.map((item) => item[this.labelProp]);
		},
		maxTagsReached() {
			return this.model.selected.length == MAX_TAGS;
		}
	},
	methods: {
		focusInput() {
			this.$refs['search-input'].focus();
		},
		reset() {
			this.items = [];
		},
		resetToken() {
			this.model.token = '';
			this.$emit('value-change', this.model.token);
		},
		update: debounce(function () {
			if (this.model.token.length >= SEARCH_MIN_CHARS) {
				this.$emit('search', this.model.token);
			} else {
				this.$emit('value-change', this.model.token);
				this.reset();
			}
		}, 200),
		// getHighlighted(text) {
		// 	let regex = new RegExp('(.*)(' + this.model.token + ')(.*)', 'i');
		// 	let match = regex.exec(text);
		// 	return match ? (match[1] + '<strong>' + match[2] + '</strong>' + match[3]).trim() : text;
		// },
		selectItem(index) {
			this.select(index);
			this.send();
			this.reset();
		},
		select(index) {
			this.model.selected = uniq([...this.model.selected, this.items[index]]);
			if (index != null && typeof index != 'undefined') {
				this.model.token = '';
			}
			this.activeItem = null;
		},
		send() {
			if (this.sendLabel) {
				this.$emit('input', this.model.token);
			} else {
				this.$emit('input', this.model.selected);
			}
			this.reset();
		},
		moveDown() {
			if (this.items.length) {
				if (this.activeItem == null) {
					this.activeItem = 0;
				} else if (this.activeItem == this.items.length - 1) {
					this.activeItem = null;
				} else {
					this.activeItem++;
				}
				if (this.activeItem != null) {
					this.model.token = this.items[this.activeItem].text;
					this.scrollToSelectedElement();
					// this.select(this.activeItem);
				}
			}
		},
		moveUp() {
			if (this.items.length) {
				if (this.activeItem == null) {
					this.activeItem = this.items.length - 1;
				} else if (this.activeItem == 0) {
					this.activeItem = null;
				} else {
					this.activeItem--;
				}
				if (this.activeItem != null) {
					this.model.token = this.items[this.activeItem].text;
					this.scrollToSelectedElement();
					// this.select(this.activeItem);
				}
			}
		},
		scrollToSelectedElement() {
			const selectedElement = this.$refs?.searchItems[this.activeItem];
			const listbox = this.$refs['dropdown-menu-list'];
			listbox.scrollTop = selectedElement.offsetTop - 56;
		},
		hit(e) {
			if (!this.handleMNumber()) {
				this.select(this.activeItem);
				if (this.model.selected) {
					this.send();
				}
				e.preventDefault();
			}
		},
		setFocusRing() {
			this.$refs.root.classList.add(FOCUS_CSS_CLASS);
		},
		handleMNumber() {
			const isMnumber = M_NUMBER_REGEX.test(this.model.token);
			if (isMnumber) {
				this.model.selected = [{ type: 'MID', value: this.model.token.toUpperCase() }];
				this.$emit('input', this.model.selected);
			}
			this.resetToken();
			return isMnumber;
		},
		onBlur() {
			this.$nextTick(() => {
				this.removeFocusRing();
				this.handleMNumber();
			});
		},
		onTab(e) {
			this.reset();
			if (!e.shiftKey) {
				this.$emit('tab');
			}
		},
		removeFocusRing() {
			this.$refs.root.classList.remove(FOCUS_CSS_CLASS);
		},
		removeTag(index) {
			this.model.selected.splice(index, 1);
		}
	}
};
</script>

<style lang="css" scoped>
@import '../../../common/variables.pcss';
.stretched-layer {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1000;
}

.search-autosuggest {
	background-color: var(--white);
	position: relative;
}

.search-autosuggest-form__overflow-container {
	width: 100%;
	position: relative;

	@media (--desktop) {
		border-bottom: 1px solid var(--grey-c5);
		height: 44px;
		overflow: hidden;
		width: 210px;
	}

	&:hover {
		overflow: visible;
	}
}

.search-autosuggest--has-focus .search-autosuggest-form__overflow-container {
	overflow: visible;
}

.search-autosuggest-form__hover-container {
	@media (--desktop) {
		background: var(--white);
		border-bottom: 0;
		margin-left: -1px;
	}
}

.search-autosuggest__tags {
	border: 1px solid var(--grey-c5);
	border-bottom: 0;
	padding: 5px 10px 4px 10px;
	display: flex;
	flex-wrap: wrap;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;

	@media (--desktop) {
		border-radius: 0;
	}
}

.search-autosuggest__tags + .search-autosuggest-form__input-container input {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

.search-autosuggest__tag {
	background-color: var(--green);
	color: var(--white);
	border-radius: 4px;
	font-size: 12px;
	margin: 5px;
	padding: 4px 22px 4px 4px;
	max-width: 100%;
	overflow: hidden;
	position: relative;
	text-overflow: ellipsis;
	cursor: default;
	white-space: nowrap;
}

.search-autosuggest__tag button {
	background-color: transparent;
	border: 0;
	height: 100%;
	padding: 0;
	position: absolute;
	right: 0;
	top: 0;
	width: 22px;
	transition: 0.2;

	& svg {
		margin: 0 auto;
		width: 18px;
		fill: white;
	}

	&:hover {
		opacity: 0.8;
	}
}

.search-autosuggest-form__input-container {
	position: relative;
}

.search-autosuggest-form__input {
	box-shadow: 0px 2px 0px 0px transparent;
	border: 1px solid var(--grey-c5);
	box-sizing: border-box;
	font-size: 16px;
	height: 44px;
	padding: 10px 15px;
	color: var(--text-primary);
	width: 100%;
	transition: 0.2s;
	font-family: 'regular', Arial, sans-serif;
	border-radius: 4px;

	@media (--desktop) {
		border-radius: 0;
	}

	&:focus {
		box-shadow: 0px 2px 0px 0px rgba(63, 81, 181, 1);
		outline: none;
	}
}

.search-autosuggest-form__input--left.search-autosuggest-form__input--search-hidden {
	padding-left: 12px;
}

.search-autosuggest-form__input--right.search-autosuggest-form__input--search-hidden {
	padding-right: 12px;
}

.search-autosuggest-result {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
}

.search-autosuggest-result__list {
	background-color: var(--white);
	border: 1px solid var(--grey-c5);
	border-radius: 4px;
	margin: 43px 0 0 0;
	max-height: 230px;
	overflow-x: hidden;
	overflow-y: auto;
	padding: 0;
	position: absolute;
	z-index: 1010;
	width: 100%;
}

.search-autosuggest-result__list-item {
	list-style: none;
	position: relative;
}

.search-autosuggest-result__list-item--active {
	background-color: var(--yellow);
}

.search-autosuggest-result__link {
	color: #4a4a4a;
	display: block;
	font-family: Source Sans Pro, sourcesanspro-regular, regular, Arial, sans-serif;
	font-size: 16px;
	margin: 0;
	padding: 10px 15px;
	transition: 0.2s;
	text-align: left;
	font-weight: normal;

	&:hover {
		background-color: var(--yellow);
		color: #4a4a4a;
		cursor: pointer;
	}
}
</style>
